import axios from "axios";
import API from "../api";

export async function get(mainToken, telephone) {
  const params = {
    telephone: encodeURI(telephone)
  };
  return new Promise(resolve => {
    const url = API.verifierTelephone.main;
    const request = axios.get(url, {
      params,
      headers: {
        Authorization: `bearer ${mainToken}`
      }
    });
    return request
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        resolve({ error: true, res: err });
      });
  });
}
